import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  ReasignacionVendedorDispatcher,
  reasignacionVendedorDispatcher
} from "./ReasignacionVendedor.dispatcher";
import {
  ReasignacionVendedorStore,
  reasignacionVendedorStore
} from "./ReasignacionVendedor.store";
import ReasignacionVendedorComponent from "../../../components/comisionesAnualidad/reasignacion";

interface Props
  extends ReasignacionVendedorStore,
    ReasignacionVendedorDispatcher {}

@ReduxConnect(reasignacionVendedorStore, reasignacionVendedorDispatcher)
export default class ReasignacionVendedorContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Reasignación Masiva de Vendedores - Anualidades" />
          <ReasignacionVendedorComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
